import { DELETE } from '../../constants/actionsTypes';
import { CAMPAIGN } from '../../constants/entityTypes';
import ChangeModel from '../../models/ChangeModel';
import changesQueueInstance from '../ChangesQueue';

class CampaignChangeManager {
  changesQueue: typeof changesQueueInstance;
  entityType: string;

  constructor(changesQueue) {
    this.changesQueue = changesQueue;
    this.entityType = CAMPAIGN;
  }

  delete(campaignId) {
    const change = new ChangeModel(this.entityType, DELETE, campaignId, null);
    return this.changesQueue.addChange(change);
  }
}

export default new CampaignChangeManager(changesQueueInstance);
